// Tłumaczenia (react-i18next). Język wynika z kraju wersji serwisu (src/kraj.js).
//
// Słowniki leżą w src/locales/<język>/<przestrzeń>.json. Polski tekst w słowniku
// `pl` jest DOKŁADNIE tym, co strona pokazywała przed wyjęciem tekstów, więc wersja
// polska wygląda identycznie. Brakujący klucz w innym języku spada do polskiego
// (fallbackLng), żeby niedokończone tłumaczenie nie pokazywało pustych miejsc.
//
// Teksty wyjmujemy ekran po ekranie. Przestrzenie: `zgodnosc` (strona zgodności),
// `wspolne` (nawigacja, stopka i elementy na wszystkich stronach), `model` (strona
// modelu), `lista` (listingi i filtry), `glowna` (strona główna), `porownanie`
// (porównanie produktów i okazje), `asystent` (kreator i wersja prosta asystenta doboru),
// `zestaw` (karta zestawu i ekran potwierdzenia), `elektryka` (dobór łańcuchów, schemat,
// prądy i napięcia), `projekt` (dokument VoltValue Projekt i prognoza produkcji).

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { KRAJ } from './kraj';
import plZgodnosc from './locales/pl/zgodnosc.json';
import roZgodnosc from './locales/ro/zgodnosc.json';
import plWspolne from './locales/pl/wspolne.json';
import roWspolne from './locales/ro/wspolne.json';
import plModel from './locales/pl/model.json';
import roModel from './locales/ro/model.json';
import plLista from './locales/pl/lista.json';
import roLista from './locales/ro/lista.json';
import plGlowna from './locales/pl/glowna.json';
import roGlowna from './locales/ro/glowna.json';
import plPorownanie from './locales/pl/porownanie.json';
import roPorownanie from './locales/ro/porownanie.json';
import plAsystent from './locales/pl/asystent.json';
import roAsystent from './locales/ro/asystent.json';
import plZestaw from './locales/pl/zestaw.json';
import roZestaw from './locales/ro/zestaw.json';
import plElektryka from './locales/pl/elektryka.json';
import roElektryka from './locales/ro/elektryka.json';
import plProjekt from './locales/pl/projekt.json';
import roProjekt from './locales/ro/projekt.json';

i18n.use(initReactI18next).init({
  resources: {
    pl: { zgodnosc: plZgodnosc, wspolne: plWspolne, model: plModel, lista: plLista, glowna: plGlowna, porownanie: plPorownanie, asystent: plAsystent, zestaw: plZestaw, elektryka: plElektryka, projekt: plProjekt },
    ro: { zgodnosc: roZgodnosc, wspolne: roWspolne, model: roModel, lista: roLista, glowna: roGlowna, porownanie: roPorownanie, asystent: roAsystent, zestaw: roZestaw, elektryka: roElektryka, projekt: roProjekt },
  },
  lng: KRAJ.jezyk,
  fallbackLng: 'pl',
  defaultNS: 'zgodnosc',
  interpolation: { escapeValue: false }, // React sam zabezpiecza tekst
  returnNull: false,
});

// Język dokumentu dla czytników ekranu i wyszukiwarek (index.html ma na sztywno lang="en").
if (typeof document !== 'undefined') document.documentElement.lang = KRAJ.jezyk;

export default i18n;
